import { useMemo } from 'react'

import Countdown from '../Countdown/Countdown'

import { useGetGGPRewardsCycleSeconds, useGetGGPRewardsCycleStartTime } from '@/hooks/ggpRewards'

const GGPReward = () => {
  const { data: rewardsCycleStartTime } = useGetGGPRewardsCycleStartTime()
  const { data: rewardsCycleSeconds } = useGetGGPRewardsCycleSeconds()

  const countdownTimestamp = useMemo(() => {
    if (!rewardsCycleStartTime || !rewardsCycleSeconds) return null

    const startTimeSeconds = Number(rewardsCycleStartTime)
    const cycleSeconds = Number(rewardsCycleSeconds)
    const endTimeSeconds = startTimeSeconds + cycleSeconds
    const adjustedEndTimeSeconds = endTimeSeconds - 8 * 60 * 60

    return adjustedEndTimeSeconds
  }, [rewardsCycleStartTime, rewardsCycleSeconds])

  if (!countdownTimestamp) return null

  return <Countdown countdown={countdownTimestamp} />
}

export default GGPReward
